import { render, staticRenderFns } from "./ExchangeCallback.vue?vue&type=template&id=559bbc52&lang=pug"
import script from "./ExchangeCallback.vue?vue&type=script&lang=js"
export * from "./ExchangeCallback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports